import React, { Component } from 'react'
import { Button, Columns } from 'components/elements'
import RidingExperienceInput from '../../profile/riderExperienceInput/ridingExperienceInput'
import './insuranceScreen.css'

class RiderExpScreen extends Component {
  constructor(props) {
    super(props)

    this.state = {
      expError: false,
      ridingExp: [],
    }
  }

  componentDidMount() {
    this.props.onScreenLoad('riding_exp')
  }

  updateRidingExp = (newExp) => {
    this.setState({ ridingExp: newExp, expError: false })
  }

  checkRidingExperience = () => {
    this.setState({
      expError: false,
    })

    if (this.state.ridingExp.length === 0) {
      this.setState({
        expError: true,
        loading: false,
      })
      return false
    } else {
      this.props.onSuccess()
    }
  }

  render() {
    return (
      <React.Fragment>
        <Columns>
          <Columns.Column>
            <h3 className="title is-size-4 has-text-weight-extra-bold has-text-centered">
              {this.props.header}
            </h3>
            <p className="title subtitle is-size-6 has-text-centered">
              Please enter information on your riding history.
            </p>
            {this.props.instructions && (
              <p style={{ textAlign: 'center' }}>{this.props.instructions}</p>
            )}
            <RidingExperienceInput
              onChange={this.updateRidingExp}
              expError={this.state.expError}
              ridingExperience={this.state.ridingExp}
              align="centered"
              outlinedButton={true}
            />

            <div className="has-text-centered mt-5">
              <Button
                color="primary"
                size="medium"
                className="button-with-bottom-margin"
                onClick={() => this.checkRidingExperience()}
              >
                Next
              </Button>
              {this.props.skippable && (
                <div>
                  <span
                    className="has-text-dark-grey is-size-7 mt-3 finger-pointer"
                    onClick={() => this.props.onSuccess()}
                  >
                    I'll do this later
                  </span>
                </div>
              )}{' '}
            </div>
          </Columns.Column>
        </Columns>
      </React.Fragment>
    )
  }
}

export default RiderExpScreen

RiderExpScreen.defaultProps = {
  onSuccess: function() {
    alert('Success')
  },
  skippable: true,
  header: 'Add your Motorcycle Experience',
  instructions: null,
  onScreenLoad: function() {},
}
